(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mavisse-category-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = (root) => root.querySelectorAll('.mv-mega:not([data-bound]), .mv-category-bar__info:not([data-bound])').forEach(menu => {
    menu.dataset.bound = 'true';
    const siblings = () => menu.closest('nav').querySelectorAll('.mv-mega, .mv-category-bar__info');
    const open = () => { siblings().forEach(other => { if(other !== menu) other.open = false; }); menu.open = true; };
    menu.addEventListener('pointerenter', event => { if(event.pointerType === 'mouse' && menu.classList.contains('mv-mega')) open(); });
    menu.addEventListener('pointerleave', event => { if(event.pointerType === 'mouse' && menu.classList.contains('mv-mega') && !menu.contains(document.activeElement)) menu.open = false; });
    menu.addEventListener('toggle', () => { if(menu.open) siblings().forEach(other => { if(other !== menu) other.open = false; }); });
    menu.addEventListener('focusout', event => { if(!menu.contains(event.relatedTarget)) menu.open = false; });
    menu.addEventListener('keydown', event => { if(event.key === 'Escape') { menu.querySelector('summary').focus(); menu.open = false; event.stopPropagation(); } });
  });
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('click', event => document.querySelectorAll('.mv-mega[open], .mv-category-bar__info[open]').forEach(menu => { if(!menu.contains(event.target)) menu.open = false; }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mavisse-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  if(event.target.closest('[data-mv-back-top]')) window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mavisse-review-demo"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = root => root.querySelectorAll('[data-review-carousel]:not([data-bound])').forEach(carousel => {
    carousel.dataset.bound = 'true';
    const track = carousel.querySelector('.mv-review-demo__track');
    const prev = carousel.querySelector('[data-review-prev]');
    const next = carousel.querySelector('[data-review-next]');
    const update = () => {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    const move = direction => {
      const card = track.querySelector('article');
      if(!card) return;
      const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
      track.scrollBy({left:direction * step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive:true});
    track.addEventListener('keydown', event => {
      if(event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    const observer = new ResizeObserver(update); observer.observe(track);
    document.addEventListener('shopify:section:unload', event => { if(event.target.contains(carousel)) observer.disconnect(); });
    update();
  });
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
  document.addEventListener('shopify:block:select', event => {
    if(event.target.closest('[data-review-carousel]')) event.target.scrollIntoView({behavior:'auto',block:'nearest',inline:'nearest'});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mavisse-welcome-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-mv-welcome]').forEach(dialog => {
    if (dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const editor = dialog.dataset.editor === 'true';
    const dismissedKey = 'mavisse.welcome.dismissed';
    const subscribedKey = 'mavisse.welcome.subscribed';
    const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
    const write = (storage, key) => { try { window[storage].setItem(key, '1'); } catch {} };
    let previousFocus;
    const open = () => { if (!dialog.isConnected || dialog.open) return; previousFocus = document.activeElement; dialog.showModal(); document.documentElement.classList.add('mv-welcome-lock'); };
    const close = () => {
      if (!dialog.open || dialog.hasAttribute('data-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !dialog.animate) { dialog.close(); return; }
      dialog.setAttribute('data-closing', '');
      const animation = dialog.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(10px)'}], {duration:300,easing:'ease-out',fill:'forwards'});
      const finish = () => { dialog.close(); animation.cancel(); dialog.removeAttribute('data-closing'); };
      animation.finished.then(finish, finish);
    };
    dialog.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('mv-welcome-lock'); if (!editor) write('sessionStorage', dismissedKey); if (previousFocus?.isConnected) previousFocus.focus(); });
    const form = dialog.querySelector('form');
    const ownSubmission = location.hash === '#' + form.id;
    const success = dialog.querySelector('[data-welcome-success]');
    const error = dialog.querySelector('[data-welcome-error]');
    const afterPrivacy = () => {
      let scheduled = false;
      let complete = false;
      const privacyReady = () => {
        const privacy = window.Shopify?.customerPrivacy;
        if (!privacy || typeof privacy.currentVisitorConsent !== 'function' || typeof privacy.shouldShowBanner !== 'function') return false;
        try {
          const consent = privacy.currentVisitorConsent();
          const decided = ['analytics', 'marketing', 'preferences'].every(key => consent[key] === 'yes' || consent[key] === 'no');
          return decided || privacy.shouldShowBanner() === false;
        } catch { return false; }
      };
      const check = () => {
        if (complete || scheduled || !dialog.isConnected || !privacyReady()) return;
        scheduled = true;
        setTimeout(() => {
          scheduled = false;
          if (complete || !dialog.isConnected || !privacyReady()) return;
          complete = true;
          document.removeEventListener('visitorConsentCollected', check);
          open();
        }, 900);
      };
      document.addEventListener('visitorConsentCollected', check);
      if (window.Shopify?.customerPrivacy) check();
      else if (window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
          if (!error) check();
        });
      }
    };
    if (!editor && success && ownSubmission) { write('localStorage', subscribedKey); write('sessionStorage', dismissedKey); afterPrivacy(); }
    else if (!editor && error && ownSubmission) afterPrivacy();
    else if (!editor && !success && !read('sessionStorage', dismissedKey) && !read('localStorage', subscribedKey)) afterPrivacy();
    document.addEventListener('shopify:section:select', event => { if (editor && event.detail.sectionId === dialog.dataset.section) open(); });
    document.addEventListener('shopify:section:deselect', event => { if (editor && event.detail.sectionId === dialog.dataset.section && dialog.open) close(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-banner"]) return;
  try {
    
(() => {
 const init = () => document.querySelectorAll('[data-mv-cookies]').forEach(dialog => {
  if(dialog.dataset.ready) return;
  dialog.dataset.ready='true';
  const editor=dialog.dataset.editor==='true';
  let api,previousFocus,busy=false,finished=false;
  const error=dialog.querySelector('[data-cookie-error]');
  const signal=state=>{dialog.dataset.consentState=state;document.dispatchEvent(new CustomEvent('mavisse:privacy-ready',{detail:{state}}));};
  const open=()=>{if(dialog.open||!dialog.isConnected)return;previousFocus=document.activeElement;dialog.showModal();document.documentElement.classList.add('mv-cookie-lock');dialog.dataset.consentState='pending';};
  const finish=()=>{if(finished)return;finished=true;if(dialog.open)dialog.close();signal('ready');};
  const setBusy=value=>{busy=value;dialog.querySelectorAll('[data-cookie-choice]').forEach(b=>b.disabled=value);};
  const load=()=>new Promise((resolve,reject)=>{
   if(window.Shopify?.customerPrivacy){resolve(window.Shopify.customerPrivacy);return;}
   if(!window.Shopify?.loadFeatures){reject(new Error('Unavailable'));return;}
   const timer=setTimeout(()=>reject(new Error('Timeout')),8000);
   window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],e=>{clearTimeout(timer);if(e||!window.Shopify.customerPrivacy)reject(e||new Error('Unavailable'));else resolve(window.Shopify.customerPrivacy);});
  });
  dialog.addEventListener('close',()=>{document.documentElement.classList.remove('mv-cookie-lock');if(previousFocus?.isConnected)previousFocus.focus();});
  const dismiss=()=>{if(busy)return;dialog.close();signal('dismissed');};
  dialog.addEventListener('cancel',e=>{e.preventDefault();dismiss();});
  dialog.querySelector('[data-cookie-close]').addEventListener('click',dismiss);
  dialog.querySelectorAll('[data-cookie-choice]').forEach(button=>button.addEventListener('click',async()=>{
   if(busy)return;
   if(editor){dialog.close();return;}
   setBusy(true);error.hidden=true;
   try{
    api=api||await load();
    const value=button.dataset.cookieChoice==='accept';
    await new Promise((resolve,reject)=>{
     const timer=setTimeout(()=>reject(new Error('Timeout')),8000);
     api.setTrackingConsent({analytics:value,marketing:value,preferences:value},result=>{clearTimeout(timer);result?.error?reject(new Error(result.error)):resolve();});
    });
    finished=false;finish();
   }catch{error.hidden=false;}finally{setBusy(false);}
  }));
  document.querySelectorAll('[data-cookie-settings]').forEach(b=>b.addEventListener('click',()=>{finished=false;open();}));
  document.addEventListener('visitorConsentCollected',()=>{if(!busy&&dialog.isConnected&&!editor){finished=false;finish();}});
  document.addEventListener('shopify:section:select',e=>{if(editor&&e.detail.sectionId===dialog.dataset.section)open();});
  document.addEventListener('shopify:section:deselect',e=>{if(editor&&e.detail.sectionId===dialog.dataset.section)dialog.close();});
  if(!editor){
   dialog.dataset.consentState='pending';
   load().then(privacy=>{
    api=privacy;const consent=api.currentVisitorConsent();
    const known=['analytics','marketing','preferences'].every(k=>consent[k]==='yes'||consent[k]==='no');
    if(known&&!api.shouldShowBanner())finish();else open();
   }).catch(()=>{open();error.hidden=false;});
  }
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
